<script>
import {
  getProductConsumption,
} from '@api/store.service'

export default {
  name: 'Consumption',
  props: {
    id: {
      type: String,
      required: true,
    },
    getData: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      data: {
        cost: 0,
      },
    }
  },
  async created() {
    if (this.getData) await this.getInfo()
  },
  methods: {
    async getInfo() {
      const { data } = (await getProductConsumption.execute({
        id: this.id,
      }))
      this.data = data
    },
  },
  render() {
    return this.$scopedSlots.default({
      info: this.data,
      cost: `~ ${this.getSplittedHtml(this.data.cost)}`,
    })
  },
}

</script>
